import { RootState } from '../index';

export const selectLatestPerformanceIndicatorsReport = (state: RootState): any => state.performanceIndicators.currentReport;
export const selectLatestPerformanceIndicatorsReportLoading = (state: RootState): any => state.performanceIndicators.currentReportLoading;
